import {
  SETTING_LAYOUT_ALL,
  SETTING_LAYOUT_GET,
  SETTING_LAYOUT_DEL,
  SETTING_LAYOUT_PUT,
  SETTING_LAYOUT_POST,
  SETTING_LAYOUT_LOADING,
  SETTING_LAYOUT_ERROR,
} from '../../actions/types';

const initialState = {
  productType: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SETTING_LAYOUT_LOADING:
      return { isLoading: true, isCompleted: true };
    case SETTING_LAYOUT_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case SETTING_LAYOUT_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SETTING_LAYOUT_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SETTING_LAYOUT_POST:
      return { isLoading: false, isCompleted: true };
    case SETTING_LAYOUT_PUT:
      return { isLoading: false, isCompleted: true };
    case SETTING_LAYOUT_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
